var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column skeleton-loader ml-4"},[_c('v-skeleton-loader',{attrs:{"type":"chip"}}),_c('v-skeleton-loader',{attrs:{"type":"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }